import React from 'react';
import { Modal, Button, DatePicker } from 'antd';
import Wrapper from './style';
import PropTypes from 'prop-types';

const FilterTransactions = ({ showModal, hideModal, searchData, clearFilter, setSearchData, handleFilters }) => {
  const { RangePicker } = DatePicker;

  // let initial = {
  //   searchCategory,
  //   searchType,
  //   searchAccount,
  //   searchVendo,
  //   searchStatus,
  //   searchAmount,
  //   searchDate,

  // }



  return (
    <Modal
      visible={showModal}
      closable={false}
      footer={null}
      centered
      onCancel={() => {
        hideModal(false);
      }}
      width='15%'
    >
      <Wrapper>
        <div className="cw-content">

          <div >


            <div className="input-content">
              <div className="label">Account Type</div>
              <select value={searchData.searchCategory} onChange={(e) => { setSearchData({ ...searchData, searchCategory: e.target.value }) }} className='label border border-dark size="2"  col-md-10'>
                <option value='' >Show All</option>
               </select>
            </div>
           
            <div className="input-content">
              <div className="label">Status</div>
              <select value={searchData.searchStatus} onChange={(e) => setSearchData({ ...searchData, searchStatus: e.target.value })} className='label border border-dark col-md-10'>
                <option value=''>Show All</option>
              </select>
            </div>
            <div className="input-content label">
              <div className="label">Amount</div>
              <input value={searchData.searchAmount} onChange={(e) => { setSearchData({ ...searchData, searchAmount: e.target.value }) }} className="input-content label" />
            </div>
            <div className="label">Date Range</div>
            <div className='label'>
              <RangePicker value={searchData.searchDate} onChange={(date) => { setSearchData({ ...searchData, searchDate: date }) }} />
            </div>
          </div>

        </div>
      </Wrapper>

      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyItems: 'stretch',
          justifyContent: 'stretch',
        }}
      >
        <Button
          style={{
            fontSize: '8px',
            alignItems: 'center',
            width: 70
          }}
          onClick={clearFilter}
        >Clear</Button>
        <Button
          style={{
            background: '#FF4B01',
            color: '#fff',
            fontSize: '8px',
            alignItems: 'center',
            width: 70
          }}
          onClick={handleFilters}
        >
          Apply filter
        </Button>
      </div>
    </Modal>
  );
};

FilterTransactions.propTypes = {
  showModal: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
  searchData: PropTypes.object.isRequired,
  clearFilter: PropTypes.func.isRequired,
  setSearchData: PropTypes.func.isRequired,
  handleFilters: PropTypes.func.isRequired,
};

export default FilterTransactions;
